import React from 'react'
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom'
import App from './App'
import loadable from './utils/loadable'
/*
const Carrier = loadable(()=>import('./pages/carrier'))
const CarrierBuy = loadable(()=>import('./pages/carrier/buy'))
const CarrierCenter = loadable(()=>import('./pages/carrier/center'))
const CarrierCate = loadable(()=>import('./pages/carrier/cate'))
const FissionPrizes = loadable(()=>import('./pages/fission/prizes'))
const FissionMyPrizes = loadable(()=>import('./pages/fission/myPrizes'))
const FissionPrizeDetail = loadable(()=>import('./pages/fission/prizeDetail'))
const FissionInvite = loadable(()=>import('./pages/fission/invite'))
const FissionBeInvite = loadable(()=>import('./pages/fission/beInvited'))
const FissionAddress = loadable(()=>import('./pages/fission/address'))
*/
/*
const Download = loadable(()=>import('./pages/download'))

const ActivitySpecial = loadable(()=>import('./pages/activity/special'))
const ActivityAlbum = loadable(()=>import('./pages/activity/album'))
*/
import Download from './pages/download'

import ActivitySpecial from './pages/activity/special'
import ActivityAlbum from './pages/activity/album'
/*
const surveyIndex = loadable(()=>import('./pages/survey/index'))
const SurveyQuestion = loadable(()=>import('./pages/survey/question'))
const SurveyResult = loadable(()=>import('./pages/survey/result'))
const Survey2Index = loadable(()=>import('./pages/survey2/index'))
const Survey2Question = loadable(()=>import('./pages/survey2/question'))
const Survey2Result = loadable(()=>import('./pages/survey2/result'))
const Survey3Index = loadable(()=>import('./pages/survey3/index'))
const Survey3Question = loadable(()=>import('./pages/survey3/question'))
const Survey3Result = loadable(()=>import('./pages/survey3/result'))
*/
/*
const articleVipJd = loadable(()=>import('./pages/article/vipjd'))

const vipInvite = loadable(()=>import('./pages/vip/invite'))
const vipFission = loadable(()=>import('./pages/vip/fission'))
*/
import articleVipJd from './pages/article/vipjd'

import vipInvite from './pages/vip/invite'
import vipFission from './pages/vip/fission'
/*
const ShareIndex = loadable(()=>import('./pages/share/index'))

const ShareOpen = loadable(()=>import('./pages/share/open'))
const ShareDownload = loadable(()=>import('./pages/share/download'))
const ShareMyAccount = loadable(()=>import('./pages/share/myAccount'))
const ShareCashExchange = loadable(()=>import('./pages/share/cashExchange'))
const ShareWithdraw = loadable(()=>import('./pages/share/withdraw/index'))
const ShareRankingList = loadable(()=>import('./pages/share/rankingList'))
const ShareTaskCenter = loadable(()=>import('./pages/share/task/index'))
const ShareTaskPrentice = loadable(()=>import('./pages/share/task/prentice'))
const ShareTaskPartner = loadable(()=>import('./pages/share/task/partner'))
const ShareTaskDiscountAlbum = loadable(()=>import('./pages/share/task/discountAlbum'))
const ShareTaskRefundAlbum = loadable(()=>import('./pages/share/task/refundAlbum'))
const ShareTaskRefundAlbumRule = loadable(()=>import('./pages/share/task/refundAlbumRule'))
const ShareWithdrawDetail = loadable(()=>import('./pages/share/withdraw/detail'))
const ShareWithdrawSuccess = loadable(()=>import('./pages/share/withdraw/success'))
const ShareLotteryIndex = loadable(()=>import('./pages/share/lotteryDraw/index'))
const ShareLotteryBagWheel = loadable(()=>import('./pages/share/lotteryDraw/bagWheel'))
const ShareLotteryRules = loadable(()=>import('./pages/share/lotteryDraw/rules'))
const ShareLotteryRecord = loadable(()=>import('./pages/share/lotteryDraw/record'))
const ShareSpreadEntrance = loadable(()=>import('./pages/share/spread/entrance'))
const ShareSpreadOpen = loadable(()=>import('./pages/share/spread/open'))
const ShareSpreadRecord = loadable(()=>import('./pages/share/spread/record'))
*/
/*
const AlbumDetail = loadable(()=>import('./pages/album/detail'))

//语音日记
const DiaryDetailIndex = loadable(()=>import('./pages/diary/index'))
//语音广场
const DiarySongIndex = loadable(()=>import('./pages/diary/song'))
//解锁
const DiaryUnlockPage = loadable(()=>import('./pages/diary/unlock'))
*/
import AlbumDetail from './pages/album/detail'

//语音日记
import DiaryDetailIndex from './pages/diary/index'
//语音广场
import DiarySongIndex from './pages/diary/song'
//解锁
import DiaryUnlockPage from './pages/diary/unlock'
/*
const FissionEggWinningRecord = loadable(()=>import('./pages/Fissionegg/winningRecord'))
const FissionEggProgress = loadable(()=>import('./pages/Fissionegg/progress'))
const FissionEggMyegg = loadable(()=>import('./pages/Fissionegg/myEgg'))
const FissionEggMyeggmp = loadable(()=>import('./pages/Fissionegg/myEggMp'))
const FissionEggMyeggList = loadable(()=>import('./pages/Fissionegg/myeggList'))
*/
/*
const SoundIndex = loadable(()=>import('./pages/sound/index'))
const SoundAnswerList = loadable(()=>import('./pages/sound/answerList'))
const SoundPopularityList = loadable(()=>import('./pages/sound/popularityList'))
*/
import SoundIndex from './pages/sound/index'
import SoundAnswerList from './pages/sound/answerList'
import SoundPopularityList from './pages/sound/popularityList'
/*
const BillIndex = loadable(()=>import('./pages/bill/index'))
const BillAccount = loadable(()=>import('./pages/bill/account'))
const BillShare = loadable(()=>import('./pages/bill/share'))
*/
//裂变
const ShareAwaken = loadable(() => import('./pages/share/awaken'))
const ShareAwakenUrl = loadable(() => import('./pages/share/awakenUrl'))
const DiaryIndex = loadable(() => import('./pages/diary/index'))

//拼团(团购)订单
const GroupBuyOrders = loadable(() => import('./pages/groupbuy/orders'))
//商品详情页
const GroupBuyProductDetail = loadable(() => import('./pages/groupbuy/productDetail'))
//开团页
const GroupBuyOpenGroup = loadable(() => import('./pages/groupbuy/openGroup'))

// ----------新推广大使----------
// 推广大使首页
const PromotionIndex = loadable(() => import('./pages/newpromotion/index'));
// 推广大使邀请记录
const PromotionInviteRecords = loadable(() => import('./pages/newpromotion/inviteRecords'));
// 推广大使提现
const PromotionWithdraw = loadable(() => import('./pages/newpromotion/withdraw'));
//新装机分享邀请
const PromotionNewInstall = loadable(() => import('./pages/newpromotion/newInstall'))

//新装机分享邀请优化
const PromotionNewinstallmajorization = loadable(() => import('./pages/newpromotion/newInstall'))
//新手引导
const NewhandGuidence = loadable(() => import('./pages/newGuide/index'))

//视频解锁
const VideoUnlock = loadable(() => import('./pages/video/unlock'))
//视频播放
const VideoPlay = loadable(() => import('./pages/video/play'))

/*
const DevelopTest = loadable(()=>import('./pages/test/index'))
const jumpTest = loadable(()=>import('./pages/test/jumpTest'))
*/

//Vip礼品卡
const VipGiftCard = loadable(() => import('./pages/test/giftCard'))

// Vip礼品卡
const GiftCardToVip = loadable(() => import('./pages/activity/giftCard'));

//语音新活动
const AudioActivity = loadable(() => import('./pages/diary/audioactivity/audioactivity'))
const AudioActivityDetail = loadable(() => import('./pages/diary/audioactivity/audioActivityDetail'))
const ruleDetail = loadable(() => import('./pages/diary/audioactivity/ruleDetail'))

/**
 * 上学日记
 **/
const AttendSchool = loadable(() => import('./pages/diary/attendSchool/index'))  //上学日记落地页
const AttendSchoolDetail = loadable(() => import('./pages/diary/attendSchool/detail'))//上学日记分享页
const AttendSchoolRule = loadable(() => import('./pages/diary/attendSchool/rule'))   //上学日记规则

/**
 * 快捷支付 开通会员
 */
const quickPaymentAccount = loadable(() => import('./pages/quickPayment/account'))//选择账户
const quickPaymentLoginMobile = loadable(() => import('./pages/quickPayment/loginMobile'))//手机号登录
const quickPaymentLoginWechat = loadable(() => import('./pages/quickPayment/loginWechat'))//微信登录
const vipList = loadable(() => import('./pages/quickPayment/vipList'))//微信登录
const quickPaymentSuccessVip = loadable(() => import('./pages/quickPayment/successVip'))//vip支付成功界面

const cateList = loadable(() => import('./pages/quickPayment/cateList'))//专辑列表
const cateBuy = loadable(() => import('./pages/quickPayment/cateBuy'))//专辑购买

/**
 * 微信号绑定手机号
 **/
const wechatCorrelation = loadable(() => import('./pages/account/correlation'))//微信关联手机号选择页
const wechatCorrelationMobile = loadable(() => import('./pages/account/correlationMobile'))//微信关联手机号关联页
const Down = loadable(() => import('./pages/down/index.js'));
const ETXEGIndex = loadable(() => import('./pages/down/etxeg'));

// ------------扭蛋活动------------
const TwistedeggIndex = loadable(() => import('./pages/Twistedegg/index'));

// ------------全额返现活动------------
const FullReturnIndex = loadable(() => import('./pages/fullreturn/index'));
const FullReturnDetail = loadable(() => import('./pages/fullreturn/fullreturnDetail'));
const FullReturnReceive = loadable(() => import('./pages/fullreturn/fullreturnReceive'));

// ------------跟读活动------------
const FollowReadIndex = loadable(() => import('./pages/followread/index'));
const GrowRecord = loadable(() => import('./pages/followread/growrecord'));
const Poster = loadable(() => import('./pages/followread/poster'));
const Poemshare = loadable(() => import('./pages/followread/poemshare'));

const CheckIndex = loadable(() => import('./pages/followread/checkindex'));
const CheckinPoemshare = loadable(() => import('./pages/followread/checkinpoemshare'));
const CheckinPoster = loadable(() => import('./pages/followread/checkinposter'));

// ------------app内调起微信支付------------
const WxPay = loadable(() => import('./pages/wxpay'));
const CheckOrder = loadable(() => import('./pages/wxpay/check'));
const CauseFailure = loadable(() => import('./pages/wxpay/causeFailure'));

// ------------微信登录微信购买vip------------
// https://mdevel.huhustory.com/wechatPayment/
const WxLogin = loadable(() => import('./pages/wx/wxlogin'));
const WxVipList = loadable(() => import('./pages/wx/wxviplist'));
const Agreement = loadable(() => import('./pages/wx/agreement'));

// ------------一元活动------------
const Unary = loadable(() => import('./pages/unary'));
const BbgUnary = loadable(() => import('./pages/unary/bbgUnary'));

// ------------h5支付------------
const Pay = loadable(() => import('./pages/quickPayment/pay'));
const PayDetail = loadable(() => import('./pages/quickPayment/payDetail'));

// ------------小天才手表------------
const Watch = loadable(() => import('./pages/xtc'));
const Report = loadable(() => import('./pages/xtc/report'));
const Problem = loadable(() => import('./pages/xtc/problem'));
const SchoolBegin = loadable(() => import('./pages/xtc/activity/schoolbegin'));
const XtcWritesuggestion = loadable(() => import('./pages/xtc/activity/xtcwritesuggestion'));
const XtcFreeVip = loadable(() => import('./pages/xtc/activity/xtcfreevip'));
const VipDays = loadable(() => import('./pages/xtc/vipdays'));

// 联系我们-儿童学古诗
const Contact = loadable(() => import('./pages/contact'));

// ------------互动视频------------
const KnowledgeReview = loadable(() => import('./pages/activity/knowledgereview'));
const QuestionAnswer = loadable(() => import('./pages/activity/questionanswer'));
const Interactive = loadable(() => import('./pages/activity/interactive'));

// ------------nf活动------------
const NFActivity = loadable(() => import('./pages/nfactivity/index'));
const NFActivityLetter = loadable(() => import('./pages/nfactivity/letter'));
const NFActivityResult = loadable(() => import('./pages/nfactivity/result'));

// ------------新声音乐园------------
const Sound = loadable(() => import('./pages/sound1'));
const SpecialList = loadable(() => import('./pages/sound1/specialList'));
const SoundRecord = loadable(() => import('./pages/sound1/record'));
const SoundImage = loadable(() => import('./pages/sound1/image'));

// ------------我的举报------------
const MineReport = loadable(() => import('./pages/mine/report'));
const Feedback = loadable(() => import('./pages/mine/feedback'));

// ------------主播中心------------
const Anchor = loadable(() => import('./pages/anchor'));
const AlbumList = loadable(() => import('./pages/anchor/album'));
const EditProgram = loadable(() => import('./pages/anchor/editprogram'));
const MoveAlbum = loadable(() => import('./pages/anchor/move'));
const EditAlbum = loadable(() => import('./pages/anchor/editalbum'));

const ProgramShare = loadable(() => import('./pages/activity/programshare'));
const AnchorShare = loadable(() => import('./pages/activity/anchorshare'));

// ------------主播专辑------------
const AnchorList = loadable(() => import('./pages/anchorlist'));

// ------------绘本展示------------
const Picbook = loadable(() => import('./pages/picbook'));

// ------------书屋展示------------
const Bookhouse = loadable(() => import('./pages/bookhouse'));

// ------------读书人活动------------
const Read = loadable(() => import('./pages/read'));
const ReadMain = loadable(() => import('./pages/read/main'));
const ShareRead = loadable(() => import('./pages/read/share/shareread'));
const ShareMain = loadable(() => import('./pages/read/share/sharemain'));

// ------------故事大王------------
const StoryHouse = loadable(() => import('./pages/activity/storyhouse'));
const ShareStoryHouse = loadable(() => import('./pages/activity/sharestoryhouse'));

// ------------小青蛙------------
const SmallFrog = loadable(() => import('./pages/activity/smallfrog'));
const ShareSmallFrog = loadable(() => import('./pages/activity/sharesmallfrog'));
const SmallFrogYD = loadable(() => import('./pages/activity/smallfrogYD'));
const ShareSmallFrogYD = loadable(() => import('./pages/activity/sharesmallfrogYD'));

// ------------站内消息------------
const Inform = loadable(() => import('./pages/inform'));
const Renew = loadable(() => import('./pages/activity/renew'));
const RenewCheckOrder = loadable(() => import('./pages/activity/checkorder'));

// ------------账户注销------------
const Logoff = loadable(() => import('./pages/logoff'));
const Logout = loadable(() => import('./pages/logout'));

// ------------双11------------
const Double11 = loadable(() => import('./pages/activity/double11'));

// ------------专辑分享------------
const AlbumShare = loadable(() => import('./pages/albumshare'));
const AlbumShare1 = loadable(() => import('./pages/albumshare/index1'));
const InviteRecord = loadable(() => import('./pages/albumshare/inviterecord'));
const AlbumInvite = loadable(() => import('./pages/activity/albumshare'));
const AlbumInvite1 = loadable(() => import('./pages/activity/albumshare1'));

// ------------新人活动------------
const NewPeopleActivity = loadable(() => import('./pages/new'));
const FreeVip = loadable(() => import('./pages/new/freevip'));
const WriteSuggestion = loadable(() => import('./pages/new/writesuggestion'));
const NewCheckOrder = loadable(() => import('./pages/new/checkorder'));

// ------------故事分享优化------------
const StoryShare = loadable(() => import('./pages/storyshare'));

const StoryShow = loadable(() => import('./pages/storyshow'));

// ------------收获地址------------
const Address = loadable(() => import('./pages/double11.js/address11'));
const ShippingAddress = loadable(() => import('./pages/shippingAddress'));
const FillHarvest = loadable(() => import('./pages/fillHarvest'));
const Record = loadable(() => import('./pages/record'));
const Checkrecord = loadable(() => import('./pages/checkrecord'));
const Shippingcheckorder = loadable(() => import('./pages/shippingAddress/checkorder'));
const Amend = loadable(() => import('./pages/shippingAddress/amend'));

// ------------新活动------------
const NewActivity = loadable(() => import('./pages/newActivity'));
const NewActivity61 = loadable(() => import('./pages/newActivity/index61'));

//------------播放器------------
const Player = loadable(() => import('./pages/player'));

//------------密语行动----------
const WhisperQuestions = loadable(() => import('./pages/activity/whisperQuestions'));
const WhisperInvitation = loadable(() => import('./pages/activity/whisperInvitation'));

//------------双旦----------
const ChristmasDay = loadable(() => import('./pages/activity/christmasDay'));
const WxChristmasDayEncore = loadable(() => import('./pages/wx/activity/wxChristmasDayEncore'));
const ChristmasDayEncore = loadable(() => import('./pages/activity/christmasDayEncore'));
const RegularBenefits = loadable(() => import('./pages/activity/regularBenefits'));
const RegularBenefitsEncore = loadable(() => import('./pages/activity/regularBenefitsEncore'));
//双旦分享邀请
const ChristmasDayshare = loadable(() => import('./pages/activity/christmasDayshare'));
//绘本商城
const Bookshoppingmall = loadable(() => import('./pages/store/shoppingmall'))
const BookDetails = loadable(() => import('./pages/store/bookDetails'))
const ComboDetails = loadable(() => import('./pages/store/comboDetails'))
const ShipmentsRecord = loadable(() => import('./pages/store/shipmentsRecord'))
const AddressPicker = loadable(() => import('./pages/store/addressPicker'))

// //小小出品人
const PublisherIndex = loadable(() => import('./pages/publisher/index'))
const PublisherRecord = loadable(() => import('./pages/publisher/record/inviteRecords'))
const PublisherSqueeze = loadable(() => import('./pages/publisher/squeeze'))
const PublisherWall = loadable(() => import('./pages/publisher/wall'))
//视频集
const VideoLessonIndex = loadable(() => import('./pages/videoLesson/index'))
const VideoLessonSqueeze = loadable(() => import('./pages/videoLesson/squeeze'))
const VideoLessonRecord = loadable(() => import('./pages/videoLesson/record/inviteRecords'))
//一张图
const OneImg = loadable(() => import('./pages/oneImg/index'))
//春节红包
const SpringFestivalIndex = loadable(() => import('./pages/SpringFestival/index'))
const SpringFestivalSqueeze = loadable(() => import('./pages/SpringFestival/squeeze'))
//商城
const ShoppingMallIndex = loadable(() => import('./pages/shoppingMall/index'))
const ShoppingMallDetails = loadable(() => import('./pages/shoppingMall/details'))
const ShoppingMallEnd = loadable(() => import('./pages/shoppingMall/end'))
const ShoppingMallPicker = loadable(() => import('./pages/shoppingMall/addressPicker'))
const ShoppingMallOrderDetails = loadable(() => import('./pages/shoppingMall/orderDetails'))
const ShoppingMallRecord = loadable(() => import('./pages/shoppingMall/record'))
const ShoppingSuccessOrFail = loadable(() => import('./pages/shoppingMall/successOrFail'))
//课程
const LessonAd = loadable(() => import('./pages/lesson/index'))
export default class ERouter extends React.Component {
    render() {
        return (
            <Router>
                <App>
                    <Switch>
                        {/* 课程 */}
                        <Route exact path='/lesson/index' component={LessonAd}></Route>
                        {/* 商城 */}
                        <Route exact path="/wechatPayment/successOrFail" component={ShoppingSuccessOrFail}></Route>
                        <Route exact path="/shoppingMall/record" component={ShoppingMallRecord}></Route>
                        <Route exact path="/wechatPayment/orderDetails" component={ShoppingMallOrderDetails}></Route>
                        <Route exact path='/wechatPayment/orderDetails/:id' component={ShoppingMallOrderDetails}></Route>
                        <Route exact path="/shoppingMall/addressPicker" component={ShoppingMallPicker}></Route>
                        <Route exact path='/wechatPayment/end/:id' component={ShoppingMallEnd}></Route>
                        <Route exact path='/wechatPayment/end' component={ShoppingMallEnd}></Route>
                        <Route exact path='/shoppingMall/index' component={ShoppingMallIndex}></Route>
                        <Route exact path="/shoppingMall/details/:id" component={ShoppingMallDetails} />
                        <Route exact path="/shoppingMall/details" component={ShoppingMallDetails} />
                        {/* 春节红包 */}
                        <Route exact path='/wechatPayment/springFestivalIndex' component={SpringFestivalIndex}></Route>
                        <Route exact path='/springFestival/squeeze' component={SpringFestivalSqueeze}></Route>
                        {/* 一张图 */}
                        <Route exact path='/oneImg/index' component={OneImg}></Route>
                        {/* 视频集 */}
                        <Route exact path='/videoLesson/record' component={VideoLessonRecord}></Route>
                        <Route exact path='/wechatPayment/squeeze' component={VideoLessonSqueeze}></Route>
                        <Route exact path='/videoLesson/index' component={VideoLessonIndex}></Route>
                        {/* {小小出品人} */}
                        <Route exact path='/publisher/index' component={PublisherIndex}></Route>
                        <Route exact path='/publisher/squeeze' component={PublisherSqueeze}></Route>
                        <Route exact path='/publisher/record' component={PublisherRecord}></Route>
                        <Route exact path='/publisher/wall' component={PublisherWall}></Route>
                        {/* 绘本商城*/}
                        <Route exact path="/store/addressPicker" component={AddressPicker}></Route>
                        <Route exact path="/store/shipmentsRecord" component={ShipmentsRecord}></Route>
                        <Route exact path="/store/shoppingmall" component={Bookshoppingmall}></Route>
                        <Route exact path="/store/bookDetails/:id" component={BookDetails}></Route>
                        <Route exact path="/wechatPayment/comboDetails/:id" component={ComboDetails} />
                        <Route exact path="/wechatPayment/comboDetails" component={ComboDetails} />
                        {/* 双旦 */}
                        <Route exact path="/activity/christmasDay" component={ChristmasDay} />
                        <Route exact path="/activity/christmasDayEncore" component={ChristmasDayEncore} />
                        <Route exact path="/wechatPayment/wxChristmasDayEncore" component={WxChristmasDayEncore} />
                        <Route exact path="/activity/regularBenefits" component={RegularBenefits} />
                        <Route exact path="/activity/regularBenefitsEncore" component={RegularBenefitsEncore} />
                        <Route exact path="/wechatPayment/christmasDayshare" component={ChristmasDayshare} />

                        {/* 密语行动 */}
                        <Route exact path="/activity/whisperquestions" component={WhisperQuestions} />
                        <Route exact path="/activity/whisperInvitation" component={WhisperInvitation} />

                        {/* 播放器 */}
                        <Route exact path="/player" component={Player} />

                        {/* 故事分享优化 */}
                        <Route exact path="/storyshare" component={StoryShare} />

                        <Route exact path="/storyshow" component={StoryShow} />

                        {/* 双十一 */}
                        <Route exact path="/address11" component={Address} />
                        <Route exact path="/shippingAddress" component={ShippingAddress} />
                        <Route exact path="/shippingAddress/checkorder" component={Shippingcheckorder} />
                        <Route exact path="/shippingAddress/amend" component={Amend} />
                        <Route exact path="/fillHarvest" component={FillHarvest} />
                        <Route exact path="/record" component={Record} />
                        <Route exact path="/checkrecord" component={Checkrecord} />

                        {/* 新活动 */}
                        <Route exact path="/newActivity" component={NewActivity} />
                        <Route exact path="/newActivity61" component={NewActivity61} />                        

                        {/* 新人活动 */}
                        <Route exact path="/newpeopleactivity" component={NewPeopleActivity} />
                        <Route exact path="/newpeopleactivity/freevip" component={FreeVip} />
                        <Route exact path="/newpeopleactivity/writesuggestion" component={WriteSuggestion} />
                        <Route exact path="/newpeopleactivity/checkorder" component={NewCheckOrder} />
                        {/* 专辑分享 */}
                        <Route exact path="/albumshare" component={AlbumShare} />
                        <Route exact path="/albumshare1" component={AlbumShare1} />
                        <Route exact path="/albumshare/inviterecord" component={InviteRecord} />
                        <Route exact path="/activity/albumshare" component={AlbumInvite} />
                        <Route exact path="/activity/albumshare1" component={AlbumInvite1} />

                        {/* 小青蛙 */}
                        <Route exact path="/activity/smallfrog" component={SmallFrog} />
                        <Route exact path="/activity/sharesmallfrog" component={ShareSmallFrog} />
                        <Route exact path="/activity/smallfrogYD" component={SmallFrogYD} />
                        <Route exact path="/activity/sharesmallfrogYD" component={ShareSmallFrogYD} />

                        {/* 故事大王 */}
                        <Route exact path="/activity/storyhouse" component={StoryHouse} />
                        <Route exact path="/wechatPayment/sharestoryhouse" component={ShareStoryHouse} />
                        <Route exact path="/activity/renew" component={Renew} />
                        <Route exact path="/activity/checkorder" component={RenewCheckOrder} />

                        {/* 双11 */}
                        <Route exact path="/activity/double11" component={Double11} />

                        {/* 站内消息 */}
                        <Route exact path="/inform" component={Inform} />
                        <Route exact path="/mine/feedback" component={Feedback} /> 

                        {/* 账户注销 */}
                        <Route exact path="/logoff" component={Logoff} /> 
                        <Route exact path="/logout" component={Logout} />                         

                        {/* 读书人活动 */}
                        <Route exact path="/read" component={Read} />
                        <Route exact path="/read/main" component={ReadMain} />
                        <Route exact path="/wechatPayment/shareread" component={ShareRead} />
                        <Route exact path="/read/share/sharemain" component={ShareMain} />

                        {/* 联系我们-儿童学古诗 */}
                        <Route exact path="/contact" component={Contact} />

                        {/* 互动视频 */}
                        <Route exact path="/activity/knowledgereview" component={KnowledgeReview} />
                        <Route exact path="/activity/questionanswer" component={QuestionAnswer} />
                        <Route exact path="/activity/interactive" component={Interactive} />

                        {/* 主播专辑 */}
                        <Route exact path="/anchorlist" component={AnchorList} />

                        {/* 绘本展示 */}
                        <Route exact path="/picbook" component={Picbook} />  

                        {/* 书屋展示 */}
                        <Route exact path="/bookhouse" component={Bookhouse} />                                                

                        {/* 主播中心 */}
                        <Route exact path="/anchor" component={Anchor} />
                        <Route exact path="/anchor/album" component={AlbumList} />
                        <Route exact path="/anchor/editprogram" component={EditProgram} />
                        <Route exact path="/anchor/move" component={MoveAlbum} />
                        <Route exact path="/anchor/editalbum" component={EditAlbum} />

                        <Route exact path="/activity/programshare" component={ProgramShare} />
                        <Route exact path="/activity/anchorshare" component={AnchorShare} />

                        {/* 我的举报 */}
                        <Route exact path="/mine/report" component={MineReport} />

                        {/* 新声音乐园 */}
                        <Route exact path="/sound1" component={Sound} />
                        <Route exact path="/sound1/specialList" component={SpecialList} />
                        <Route exact path="/sound1/record" component={SoundRecord} />
                        <Route exact path="/sound1/image" component={SoundImage} />

                        {/* 520活动 */}
                        <Route exact path="/activity/nfactivity" component={NFActivity} />
                        <Route exact path="/activity/nfactivityletter" component={NFActivityLetter} />
                        <Route exact path="/activity/nfactivityresult" component={NFActivityResult} />

                        {/* h5支付 */}
                        <Route exact path="/quickPayment/pay" component={Pay} />
                        <Route exact path="/quickPayment/paydetail" component={PayDetail} />
                        {/* 扭蛋活动 */}
                        <Route exact path="/twistedegg/index" component={TwistedeggIndex} />

                        {/* 小天才手表 */}
                        <Route exact path="/watch" component={Watch} />
                        <Route exact path="/watch/report" component={Report} />
                        <Route exact path="/watch/problem" component={Problem} />
                        <Route exact path="/wechatPayment/schoolbegin" component={SchoolBegin} />
                        <Route exact path="/vipdays" component={VipDays} />
                        <Route exact path="/wechatPayment/xtcfreevip" component={XtcFreeVip} />
                        <Route exact path="/wechatPayment/xtcwritesuggestion" component={XtcWritesuggestion} />

                        {/* app内调起微信支付 */}
                        <Route exact path="/wxpay" component={WxPay} />
                        <Route exact path="/wxpay/checkorder" component={CheckOrder} />
                        <Route exact path="/wxpay/causeFailure" component={CauseFailure} />


                        {/* 微信登录微信购买vip */}
                        <Route exact path="/wechatPayment/wxlogin" component={WxLogin} />
                        <Route exact path="/wechatPayment/wxviplist" component={WxVipList} />
                        <Route exact path="/agreement" component={Agreement} />

                        {/* 一元活动 */}
                        <Route exact path="/unary" component={Unary} />
                        <Route exact path="/bbgunary" component={BbgUnary} />

                        {/* 全额返现活动 */}
                        <Route exact path="/fullreturn/index" component={FullReturnIndex} />
                        <Route exact path="/fullreturn/detail" component={FullReturnDetail} />
                        <Route exact path="/fullreturn/receive" component={FullReturnReceive} />

                        {/* vip礼品卡 */}
                        <Route exact path="/activity/giftCard" component={GiftCardToVip} />

                        {/* 跟读活动 */}
                        <Route exact path="/followread/index" component={FollowReadIndex} />
                        <Route exact path="/followread/growrecord" component={GrowRecord} />
                        <Route exact path="/followread/poster" component={Poster} />
                        <Route exact path="/followread/poemshare" component={Poemshare} />

                        <Route exact path="/followread/checkindex" component={CheckIndex} />                        
                        <Route exact path="/followread/checkinpoemshare" component={CheckinPoemshare} />                        
                        <Route exact path="/followread/checkinposter" component={CheckinPoster} />                        

                        <Route exact path="/account/correlation" component={wechatCorrelation} />
                        <Route exact path="/account/correlationMobile" component={wechatCorrelationMobile} />

                        <Route exact path="/quickPaymentAccount" component={quickPaymentAccount} />
                        <Route exact path="/quickPayment/loginMobile" component={quickPaymentLoginMobile} />
                        <Route exact path="/quickPayment/loginWechat" component={quickPaymentLoginWechat} />
                        <Route exact path="/wechatPayment/vipList" component={vipList} />
                        <Route exact path="/quickPayment/successVip" component={quickPaymentSuccessVip} /> 

                        <Route exact path="/quickPayment/cateList" component={cateList} />
                        <Route exact path="/wechatPayment/cateBuy" component={cateBuy} />

                        {/*
                        <Route exact path="/carrier/buy" component={CarrierBuy} />
                        <Route exact path="/carrier/center" component={CarrierCenter} />
                        <Route exact path="/carrier/cate/:id" component={CarrierCate} />
                        <Route exact path="/carrier" component={Carrier} />
                        <Route exact path="/fission/prizes" component={FissionPrizes} />
                        <Route exact path="/fission/myPrizes" component={FissionMyPrizes} />
                        <Route exact path="/fission/prizeDetail/:id" component={FissionPrizeDetail} />
                        <Route exact path="/fission/invite/:id" component={FissionInvite} />
                        <Route exact path="/fission/beinvite" component={FissionBeInvite} />
                        <Route exact path="/fission/address/:id" component={FissionAddress} />
                        */}
                        <Route exact path="/download" component={Download} />

                        <Route exact path="/activity/special/:id" component={ActivitySpecial} />
                        <Route exact path="/activity/album/:id" component={ActivityAlbum} />

                        {/*
                        <Route exact path="/survey/index" component={surveyIndex} />
                        <Route exact path="/survey/question" component={SurveyQuestion} />
                        <Route exact path="/survey/result" component={SurveyResult} />
                        <Route exact path="/survey/1111/index" component={Survey2Index} />
                        <Route exact path="/survey/1111/question" component={Survey2Question} />
                        <Route exact path="/survey/1111/result" component={Survey2Result} />
                        <Route exact path="/survey/1112/index" component={Survey3Index} />
                        <Route exact path="/survey/1112/question" component={Survey3Question} />
                        <Route exact path="/survey/1112/result" component={Survey3Result} />
                        */}
                        <Route exact path="/article/vipjd" component={articleVipJd} />

                        <Route exact path="/vip/invite" component={vipInvite} />
                        <Route exact path="/lg/vip/fission" component={vipFission} />
                        {/* 裂变 */}
                        <Route exact path="/share/awaken" component={ShareAwaken} />
                        <Route exact path="/share/awakenUrl" component={ShareAwakenUrl} />
                        {/*
                        
                        <Route exact path="/share/index" component={ShareIndex} />
                        <Route exact path="/share/open" component={ShareOpen} />
                        <Route exact path="/share/download" component={ShareDownload} />
                        <Route exact path="/share/myAccount" component={ShareMyAccount} />
                        <Route exact path="/share/cashExchange" component={ShareCashExchange} />
                        <Route exact path="/share/rankingList" component={ShareRankingList} />
                        <Route exact path="/share/taskCenter" component={ShareTaskCenter} />
                        <Route exact path="/share/task/prentice" component={ShareTaskPrentice} />
                        <Route exact path="/share/task/partner" component={ShareTaskPartner} />
                        <Route exact path="/share/task/discountAlbum" component={ShareTaskDiscountAlbum} />
                        <Route exact path="/share/task/refundAlbum" component={ShareTaskRefundAlbum} />
                        <Route exact path="/share/task/refundAlbumRule" component={ShareTaskRefundAlbumRule} />

                        <Route exact path="/share/withdraw/index" component={ShareWithdraw} />
                        <Route exact path="/share/withdraw/detail" component={ShareWithdrawDetail} />
                        <Route exact path="/share/withdraw/success" component={ShareWithdrawSuccess} />
                        <Route exact path="/share/lottery/index" component={ShareLotteryIndex} />
                        <Route exact path="/share/lottery/bagWheel" component={ShareLotteryBagWheel} />
                        <Route exact path="/share/lottery/rule" component={ShareLotteryRules} />
                        <Route exact path="/share/lottery/record" component={ShareLotteryRecord} />
                        */}

                        <Route exact path="/album/detail" component={AlbumDetail} />
                        <Route exact path="/diary/index" component={DiaryDetailIndex} />
                        <Route exact path="/diary/song" component={DiarySongIndex} />
                        <Route exact path="/diary/unlock" component={DiaryUnlockPage} />

                        <Route exact path="/groupbuy/orders" component={GroupBuyOrders} />
                        <Route exact path="/groupbuy/productDetail" component={GroupBuyProductDetail} />
                        <Route exact path="/groupbuy/openGroup" component={GroupBuyOpenGroup} />

                        {/* ----------新推广大使---------- */}
                        <Route exact path="/promotion/index" component={PromotionIndex} />
                        <Route exact path="/promotion/inviteRecords" component={PromotionInviteRecords} />
                        <Route exact path="/promotion/withdraw" component={PromotionWithdraw} />
                        <Route exact path="/promotion/newInstall" component={PromotionNewInstall} />
                        <Route exact path="/promotion/newinstallmajorization" component={PromotionNewinstallmajorization} />


                        <Route exact path="/newGuide/index" component={NewhandGuidence} />

                        <Route exact path="/video/unlock" component={VideoUnlock} />
                        <Route exact path="/video/play" component={VideoPlay} />

                        {/*
                        <Route exact path="/test/jumpTest" component={jumpTest} />
                        <Route exact path="/test/giftCard" component={jumpTest} />
                        */}

                        <Route exact path="/diary/audioactivity/audioactivity" component={AudioActivity} />
                        <Route exact path="/diary/audioactivity/audioActivityDetail" component={AudioActivityDetail} />
                        <Route exact path="/diary/audioactivity/ruleDetail" component={ruleDetail} />

                        <Route exact path="/diary/attendSchool/index" component={AttendSchool} />
                        <Route exact path="/diary/attendSchool/detail" component={AttendSchoolDetail} />
                        <Route exact path="/diary/attendSchool/rule" component={AttendSchoolRule} />

                        {/* <Route exact path = "/share/spread/entrance"  component = {ShareSpreadEntrance}/>
                         <Route exact path = "/share/spread/open"  component = {ShareSpreadOpen}/>
                         <Route exact path = "/share/spread/record"  component = {ShareSpreadRecord}/> */}

                        {/*
                        <Route exact path="/lg/egg/myegg" component={FissionEggMyegg} />
                        <Route exact path="/lg/egg/mpmyegg" component={FissionEggMyeggmp} />
                        <Route exact path="/lg/egg/myeggList" component={FissionEggMyeggList} />
                        <Route exact path="/lg/egg/winningRecord" component={FissionEggWinningRecord} />
                        <Route exact path="/lg/egg/progress" component={FissionEggProgress} />
                        */}

                        <Route exact path="/lg/sound/index" component={SoundIndex} />
                        <Route exact path="/lg/sound/answerList" component={SoundAnswerList} />
                        <Route exact path="/lg/sound/popularityList" component={SoundPopularityList} />

                        {/*
                        <Route exact path="/lg/bill/index" component={BillIndex} />
                        <Route exact path="/lg/bill/account" component={BillAccount} />
                        <Route exact path="/lg/bill/share" component={BillShare} />

                        <Route exact path="/Fission" component={FissionPrizes} />
                        */}

                        <Route exact path="/" component={Down} />
                        <Route exact path="/etxeg" component={ETXEGIndex} />
                        <Route exact path="/down" component={Down} />
                    </Switch>
                </App>
            </Router>
        );
    }
}



// WEBPACK FOOTER //
// ./src/router.js